import React from "react";

import { translate } from "react-i18next";

import { Flex, Text } from "src/components";

const getErrorMessages = ({ errors, t }) => {
  const getMessage = error => {
    if (!error) {
      console.error("Could not find error within errors list", errors);
      return "There was an unknown error with this request.";
    }
    if (error.messageKey) {
      return t(error.messageKey, {
        errorMessage: error.message || "",
        defaultValue: error.message,
      });
    }
    return error.message || error.toString();
  };

  if (errors) {
    return errors.map(getMessage).join(". ");
  }

  return "";
};

const FormErrors = ({
  t,
  errors,
  errorStrings = getErrorMessages({ errors, t }),
  textOnly = false,
  light = false,
  mt = 0,
  mb = 2,
  ...props
}) =>
  textOnly ? (
    <Text mt={mt} mb={mb} color="alert" {...props}>
      {errorStrings}
    </Text>
  ) : (
    <Flex
      mt={mt}
      mb={mb}
      p={3}
      bg={light ? "white" : "orange"}
      borderRadius={1}
      {...props}
    >
      <Text
        color={light ? "orange" : "white"}
        fontWeight="semibold"
        fontSize={4}
      >
        {errorStrings}
      </Text>
    </Flex>
  );

export default translate("translations")(FormErrors);



// WEBPACK FOOTER //
// ./src/components/Form/FormErrors.js